import { nextTick } from "vue";
import type { RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "@/layouts/MainLayout.vue";
import MapView from "../views/MapView.vue";
import LoginView from "@/views/LoginView.vue";
import EventLogView from "@/views/EventLogView.vue";
import DatabaseView from "@/views/DatabaseView.vue";
import { mainStorage } from "@/composables/tools/main-storage.tools";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { title: "Oracul - Авторизация" }
  },
  {
    path: "/",
    component: MainLayout,
    redirect: "/map-view",
    children: [
      {
        path: "map-view",
        name: "map-view",
        component: MapView,
        meta: { title: "Карта", requiresAuth: true }
      },
      {
        path: "event-log",
        name: "event-log",
        component: EventLogView,
        meta: { title: "Журнал событий", requiresAuth: true }
      },
      {
        path: "database",
        name: "database",
        component: DatabaseView,
        meta: { title: "База данных", requiresAuth: true }
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    redirect: "/map-view"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const accessToken = mainStorage.getItem("access_token");
  const isAuthenticated = !!accessToken;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "login" });
  } else if (to.name === "login" && isAuthenticated) {
    next({ name: "map-view" });
  } else {
    next();
  }
});

router.afterEach(async (to: RouteLocationNormalized) => {
  await nextTick(() => {
    document.title = to.meta.title || "Oracul";
  });
});

export default router;
